// extracted by mini-css-extract-plugin
export default {"header-logo":"company_header-logo__nvaQx","logo-text":"company_logo-text__3rxCF","desktop-menu":"company_desktop-menu__oiNw9","menu-button":"company_menu-button__-q-O1"};